import { LESSON_TYPES } from 'constants/common';

import * as api from 'api/methods';

export async function updateLessonStatusViaApi({
  lessonId,
  lessonType,
  data,
}: {
  lessonId: string;
  lessonType: any;
  data: any;
}) {
  let lesson = null;

  switch (lessonType) {
    case LESSON_TYPES.QUIZ: {
      lesson = await api.updateQuizById({
        lessonId,
        data,
      });

      break;
    }
    case LESSON_TYPES.CONNECTION_QUIZ: {
      lesson = await api.updateConnectionQuizById({
        lessonId,
        data,
      });

      break;
    }
    case LESSON_TYPES.THEORY_LESSON: {
      lesson = await api.updateTheoryLessonById({
        lessonId,
        data,
      });

      break;
    }
    case LESSON_TYPES.FIGMA_LESSON: {
      lesson = await api.updateFigmaLessonById({
        lessonId,
        data,
      });

      break;
    }
    case LESSON_TYPES.DIFFERENCE_LESSON: {
      lesson = await api.updateDifferenceLessonById({
        lessonId,
        data,
      });

      break;
    }
    case LESSON_TYPES.TWO_COLUMNS_LESSON: {
      lesson = await api.updateTwoColumnsLessonById({
        lessonId,
        data,
      });

      break;
    }
    case LESSON_TYPES.COLOR_MATCH_LESSON: {
      lesson = await api.updateColorMatchLessonById({
        lessonId,
        data,
      });

      break;
    }
  }

  return lesson;
}
